import { Key } from 'react';

import { Button, Checkbox, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { useTranslation } from 'react-i18next';

import {
  ButtonsWrapper,
  CheckboxesWrapper,
  Content,
  Wrapper,
} from '@/pages/Devices/Devices/components/AccessModeFilterDropdown/AccessModeFilterDropdown.styled';

export const ADMIN_CLIENT_STATUS_FILTER_OPTIONS = ['active', 'suspended'] as const;

export type AdminClientStatusFilterOption = (typeof ADMIN_CLIENT_STATUS_FILTER_OPTIONS)[number];

interface AdminClientStatusFilterDropdownProps {
  setSelectedKeys: (keys: string[]) => void;
  selectedKeys: Key[];
  confirm: () => void;
  clearFilters: () => void;
  setSelectedFilters: (filters: string[]) => void;
}

export const AdminClientStatusFilterDropdown = (props: AdminClientStatusFilterDropdownProps) => {
  const { setSelectedKeys, selectedKeys, confirm, clearFilters, setSelectedFilters } = props;
  const { t } = useTranslation();

  const handleClear = () => {
    clearFilters?.();
    setSelectedFilters([]);
    confirm();
  };

  const handleApply = () => {
    setSelectedFilters(selectedKeys as string[]);
    confirm();
  };

  const handleChange = (e: CheckboxChangeEvent) => {
    const value = String(e.target.value);
    if (e.target.checked) {
      setSelectedKeys([value]);
    } else {
      setSelectedKeys([]);
    }
  };

  return (
    <Wrapper>
      <CheckboxesWrapper>
        {ADMIN_CLIENT_STATUS_FILTER_OPTIONS.map((option) => (
          <Content key={option}>
            <Checkbox value={option} checked={(selectedKeys as string[])?.includes(option)} onChange={handleChange}>
              <Typography.Text>{t(`adminClients.filters.${option}`)}</Typography.Text>
            </Checkbox>
          </Content>
        ))}
      </CheckboxesWrapper>
      <ButtonsWrapper>
        <Button block size="small" type="text" disabled={!selectedKeys?.length} onClick={handleClear}>
          {t('devices.sensors.table.clear')}
        </Button>
        <Button block size="small" type="primary" onClick={handleApply}>
          {t('devices.sensors.table.apply')}
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  );
};
